import { SimpleContentPageStory } from "../../lib/storyblok/types/stories/SimpleContentPageStory";
import { StoryblokStoryComponent } from "../../lib/storyblok/types/StoryblokComponent";
import { ViewModel } from "../../lib/viewModel/createViewModel";
import AnchorMenu from "../Layout/AnchorMenu/AnchorMenu";
import { AnchorMenuContextProvider } from "../Layout/AnchorMenu/AnchorMenuContext";
import AnchorMenuSection from "../Layout/AnchorMenu/AnchorMenuSection";
import { splitIntoSections } from "../Layout/AnchorMenu/splitIntoSections";
import HeroSection from "../Nestable/HeroSection";

type VM = ViewModel<SimpleContentPageStory>;

const SimpleContentPage: StoryblokStoryComponent<VM> = ({ story }) => {
  const { hero, body, anchorMenuButton, hideStickyMenu } = story.content;

  const sections = splitIntoSections(body);
  return (
    <>
      <AnchorMenuContextProvider>
        <HeroSection blocks={hero} />

        {sections.length > 1 && !hideStickyMenu && (
          <AnchorMenu sections={sections} button={anchorMenuButton?.[0]} />
        )}

        {sections?.map((section) => (
          <AnchorMenuSection
            key={`${section.href ? section.href : "index"}-${story.uuid}`}
            section={section}
          />
        ))}
      </AnchorMenuContextProvider>
    </>
  );
};

export default SimpleContentPage;
